import { Container, Box, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import CreateEntityDrawer from '../../common/create-entity-drawer/create-entity-drawer';
import DriversListing from './drivers-listing/drivers-listing';
import { useContext } from 'react';
import { AuthContext } from '../../../contexts/user-context/user-context';
import { UserType } from '../../../enums/users';
import CreateOrEditDriver from './driver-forms/create-or-edit-driver';
import PendingQRCodeGenerator from '../../driver-components/common/pending-qrcode-generator';
import { DataResources, ResourceActionType, user_has_data_model_access, user_is_admin } from '../../../utils/permissions';

function Drivers() {
  const { user, config } = useContext(AuthContext);
  const canCreateDriver = user_has_data_model_access(user, DataResources.DRIVER, ResourceActionType.CREATE)

  return (
    <div className="content-container">
      <Box>
        <Typography
          variant="h3"
          component="h3"
          sx={{ textAlign: 'center', mt: 3, mb: 3 }}
        >
          Drivers
        </Typography>
        <div style={{ width: '100%', textAlign: 'center' }}>
          <PendingQRCodeGenerator />
        </div>
        <br />
        <Grid container spacing={2}>
          <Grid xs={4}></Grid>
          <Grid xs={4}></Grid>
          <Grid xs={4} sx={{ textAlign: 'right' }}>
            <CreateEntityDrawer disabled={!canCreateDriver}>
              <CreateOrEditDriver />
            </CreateEntityDrawer>
          </Grid>
          <Grid xs={12}>
            <DriversListing />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default Drivers;
